var exports = {
  "T": "xb99ab02a--f830ea--label-container",
};

module.exports = exports;
